import { ToolsTranslations } from '@/lib/translations/types';

export interface EquityRiskPremiumValues { indexLevel: number; riskFreeRatePercent: number; earningsEstimate: number }
export interface EquityRiskPremiumResult { percent: number | null; isValid: boolean; message?: string }

// ERP = EarningsYield - RiskFree = (E / P) - r_f = (earningsEstimate / indexLevel) - (riskFreeRatePercent/100)
// Display in percent with 2 decimals
export function calculateEquityRiskPremium(values: EquityRiskPremiumValues, t?: ToolsTranslations['equityRiskPremium']): EquityRiskPremiumResult {
  const { indexLevel, riskFreeRatePercent, earningsEstimate } = values;
  if (indexLevel <= 0) return { percent: null, isValid: false, message: t?.invalid.indexLevel };
  if (earningsEstimate <= 0) return { percent: null, isValid: false, message: t?.invalid.earningsEstimate };
  const earningsYield = earningsEstimate / indexLevel; // decimal
  const riskFree = riskFreeRatePercent / 100; // decimal
  const erpDecimal = earningsYield - riskFree;
  const percent = Math.round(erpDecimal * 10000) / 100; // 2 decimals in percent form
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


